import ColorPicker from "./ColorPicker/ColorPicker";
import { Row, Col, Button } from "react-bootstrap";
import React from "react";
import IphoneScreen from "./IphoneScreen";
import IphoneScreen2 from "./IphoneScreen2";
import IphoneScreen3 from "./IphoneScreen3";
import "../Assets/Css/index.scss";

const ChurchInfoColor = (props) => {
  const {
    primary,
    setPrimary,
    secondary,
    setSecondary,
    tertiary,
    setTertiary,
    fontPrimary,
    setFontPrimary,
    fontSecondary,
    setFontSecondary,
    fontTertiary,
    setFontTertiary,
    allowSelectSubscription,
    fullLogoBlob
  } = props;

  return (
    <div className="church-info-color">
      <h2 className="section-title">Colors</h2>
      <Row>
        <Col className="col-md-2">
          <ColorPicker
            label="Background Base"
            onChange={setPrimary}
            color={primary}
            startColor={primary || `transparent`}
          />
        </Col>
        <Col className="col-md-2">
          <ColorPicker
            label="Secondary"
            onChange={setSecondary}
            color={secondary}
            startColor={secondary || `transparent`}
          />
        </Col>
        <Col className="col-md-2">
          <ColorPicker
            label="Highlights"
            onChange={setTertiary}
            color={tertiary}
            startColor={tertiary || `transparent`}
          />
        </Col>
        <Col className="col-md-2">
          <ColorPicker
            label="Button Text"
            onChange={setFontPrimary}
            color={fontPrimary}
            startColor={fontPrimary || `transparent`}
          />
        </Col>
        <Col className="col-md-2">
          <ColorPicker
            label="Secondaty Text"
            onChange={setFontSecondary}
            color={fontSecondary}
            startColor={fontSecondary || `transparent`}
          />
        </Col>
        <Col className="col-md-2">
          <ColorPicker
            label="Titles"
            onChange={setFontTertiary}
            color={fontTertiary}
            startColor={fontTertiary || `transparent`}
          />
        </Col>
      </Row>
      <h2 className="section-title">Demo</h2>
      <Row>
        <Col className="col-centered">
          <IphoneScreen
            backgroundBase={primary}
            SecundaryBackground={secondary}
            btnColor={tertiary}
            btnFont={fontPrimary}
            recoverPass={fontSecondary}
            description="Login"
            fullLogoBlob={fullLogoBlob}
          />
        </Col>
        <Col className="col-centered">
          <IphoneScreen2
            backgroundBase={primary}
            SecundaryBackground={secondary}
            eventTitleColor={fontTertiary}
            btnColor={tertiary}
            description="Events"
          />
        </Col>
        <Col className="col-centered">
          <IphoneScreen3
            backgroundBase={primary}
            SecundaryBackground={secondary}
            btnColor={secondary}
            eventTitleColor={fontTertiary}
            SecundaryHighlight={tertiary}
            btnFont={fontPrimary}
            description="Control"
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-right">
          <Button
            className="selec-sub-btn"
            type="submit"
            align="center"
            disabled={!allowSelectSubscription}
          >
            Select Subscription Plan
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default ChurchInfoColor;
